import { useMutation, useQueryClient } from '@tanstack/react-query';

import { venueUpdateNotificationsApi } from '../../../api/notifications/venueUpdateNotificationsApi';

type Props = {
  venueID: string | undefined;
  onSuccess?: () => void;
};

export const useVenueUpdateNotificationsMutation = ({ venueID, onSuccess }: Props) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: venueUpdateNotificationsApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['venueListNotifications', venueID] });
      queryClient.invalidateQueries({ queryKey: ['venueGetUnreadNotificationCount', venueID] });
      onSuccess?.();
    },
  });
};
